import { Form, Input } from "decorator-form";

import InputType from "common/form/InputType";

@Form ({title: "User Certificates Panel Config Form"})
export class Config {

	@Input({type: InputType.CHECKBOX, title: "Show Download Links"})
	public enableDownload?: boolean;

	@Input({type: InputType.CHECKBOX, title: "Enable Refine"})
	public enableRefine?: boolean;

	@Input({type: InputType.CHECKBOX, title: "Page Size (in progress)"})
	public pageSize?: number;

}



// WEBPACK FOOTER //
// ./src/panels/userCertificates/Config.ts